import axios from '../axios-config';
/*
===============================|> AUTH APIS <|===============================
01 |--> Get user data Api
02 |--> change user email Api
03 |--> change user password Api
04 |--> change user name Api
===============================|> AUTH APIS <|===============================
*/

// 01 --> Register api
const getUserData = async (handshake, mage) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: '/customer/me',
    headers: {
      Authorization: 'Bearer ' + handshake,
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02 --> Change email api
const changeUserEmail = async ({
  mage,
  customerId,
  newEmail,
  currentPassword,
}) => {
  const data = JSON.stringify({ customerId, newEmail, currentPassword });
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/customer/changeEmail',
    headers: {
      mage: 'Bearer ' + mage,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 03 --> Change user password api
const changeUserPassword = async ({
  mage,
  customerId,
  currentPassword,
  newPassword,
  confirmPassword,
}) => {
  const data = JSON.stringify({
    customerId,
    currentPassword,
    newPassword,
    confirmPassword,
  });
  const config = {
    method: 'post',
    url: '/customer/changePassword',
    headers: {
      mage: 'Bearer ' + mage,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04 --> Change user name api
const changeUserName = async ({
  mage,
  customerId,
  currentPassword,
  firstname,
  lastname,
}) => {
  const data = JSON.stringify({
    customerId,
    currentPassword,
    firstName: firstname,
    lastName: lastname,
  });
  const config = {
    method: 'post',
    url: '/customer/changeName',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const changeUserPhone = async ({ mage, mobilenumber }) => {
  const data = JSON.stringify({
    mobilenumber: '00966' + mobilenumber.slice(1),
    otptype: 'update',
    email: '',
    resendotp: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: 'customer/login/otp/send',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const sendOtp = async ({ mage, mobilenumber }) => {
  const data = JSON.stringify({
    mobilenumber: '00966' + mobilenumber,
    email: '',
    otptype: 'update',
    resendotp: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: 'customer/register/otp/send',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const verifyOtp = async ({ mage, otp, mobilenumber }) => {
  const data = JSON.stringify({
    mobilenumber: '00966' + mobilenumber,
    otpcode: otp,
    otptype: 'update',
    email: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/update-mobile-number/otp/verify',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const deleteAccount = async (mage, accId) => {
  const config = {
    method: 'delete',
    url: 'customer/deleteCustomer/' + accId,
    headers: {
      mage: `Bearer ${mage}`,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getUserData,
  changeUserEmail,
  changeUserPassword,
  changeUserName,
  changeUserPhone,
  deleteAccount,
  verifyOtp,
  sendOtp,
};
